<template>
    <vx-dropdown placement="right" teleport>
        <vx-button data-test="row-actions" type="button" color="muted-light" size="xs" aria-label="Run actions">
            <font-awesome-icon widthAuto :icon="faEllipsis" />
        </vx-button>

        <template v-slot:items>
            <vx-dropdown-item v-if="canReviewRun(props.run)" data-test="review-run" @click="emit('view', props.run.id)">
                Review resets
                <font-awesome-icon widthAuto :icon="faListCheck" />
            </vx-dropdown-item>

            <vx-dropdown-item v-else data-test="view-run" @click="emit('view', props.run.id)">
                View
                <font-awesome-icon widthAuto :icon="faEye" />
            </vx-dropdown-item>

            <vx-dropdown-item v-if="canCancelRun(props.run)" data-test="cancel-run" @click="cancelModalVisible = true">
                Cancel
                <font-awesome-icon widthAuto :icon="faBan" />
            </vx-dropdown-item>

            <vx-dropdown-item
                v-if="props.run.can_follow_up"
                data-test="follow-up-run"
                @click="followUpModalVisible = true"
            >
                Check remaining contacts
                <font-awesome-icon widthAuto :icon="faRotateRight" />
            </vx-dropdown-item>
        </template>
    </vx-dropdown>

    <kiosk-rnd-run-cancel-modal
        v-if="canCancelRun(props.run)"
        v-model:visible="cancelModalVisible"
        :run="props.run"
        @cancelled="emit('changed')"
        @conflict="emit('changed')"
    />
    <kiosk-rnd-run-follow-up-modal
        v-if="props.run.can_follow_up"
        v-model:visible="followUpModalVisible"
        :run="props.run"
        @started="emit('changed')"
        @conflict="emit('changed')"
    />
</template>

<script lang="ts" setup>
import { faBan, faEllipsis, faEye, faListCheck, faRotateRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxDropdown, VxDropdownItem } from '@voxie/frontend-components';
import { ref } from 'vue';
import { canCancelRun, canReviewRun } from '~/components/kiosk/kiosk-reassigned-numbers/rndLabels';
import KioskRndRunCancelModal from '~/components/kiosk/kiosk-reassigned-numbers/runs/KioskRndRunCancelModal.vue';
import KioskRndRunFollowUpModal from '~/components/kiosk/kiosk-reassigned-numbers/runs/KioskRndRunFollowUpModal.vue';
import type { RndRun } from '~/services/adminRndClient.types';

const props = defineProps<{ run: RndRun }>();
const emit = defineEmits<{ changed: []; view: [runId: number] }>();

const cancelModalVisible = ref(false);
const followUpModalVisible = ref(false);
</script>
